import Vue from 'vue';
import Axios from 'axios';
import Errors from '../classes/Errors';

Vue.component('question-form', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            success: false,
            submitting: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        onQuestionSubmit(event) {
            this.submitting = true;
            this.errors.clear();

            Axios
                .post(event.currentTarget.action, this.question)
                .then(response => {
                    this.submitting = false;
                    this.handleQuestionSuccess();
                })
                .catch(error => {
                    this.handleQuestionErrors(error.response.data);
                });
        },

        handleQuestionSuccess() {
            this.$root.nextQuestion();
        },

        handleQuestionErrors(data) {
            this.errors.record(data.errors);
        }
    }
});
